import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Grid/Grid.module.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/Banner/Banner.module.scss");
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/ProductList/ProductList.tsx")